import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner, List } from 'components';
import { LLTextField } from 'components/FormElements';
import { browserHistory } from 'react-router';
import * as _ from 'lodash';
import { searchUserOrganizations } from 'redux/modules/auth';
import { addOrganizationTab } from 'redux/modules/organization';
import ReactPaginate from 'react-paginate';
import * as styles from './OrganizationPicker.scss';
var OrganizationPicker = (_dec = connect(function (state) {
  return {
    searchResults: state.auth.orgSearchResults,
    searching: state.auth.searchingOrganizations
  };
}, {
  search: searchUserOrganizations,
  add: addOrganizationTab
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(OrganizationPicker, _Component);

  var _super = _createSuper(OrganizationPicker);

  function OrganizationPicker(props) {
    var _this;

    _classCallCheck(this, OrganizationPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "search", _.debounce(_this.props.search, 500));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.search(event.target.value);

      _this.setState({
        value: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (event) {
      var page = event.selected; // The pagination plugin visually lists pagination from 1, but indexes the values like arrays

      var actualPage = page + 1;

      _this.props.search(_this.state.value, actualPage);
    });

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass(OrganizationPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.search('');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var searching = this.props.searching;

      var _ref = this.props.searchResults || {},
          total = _ref.totalCount,
          organizations = _ref.organizations,
          limit = _ref.limit;

      var page = this.props.searchResults ? parseInt(this.props.searchResults.page) : 1;
      var pageIndex = page - 1;
      var results = organizations ? organizations.map(function (org) {
        return {
          text: org.name,
          onClick: function onClick() {
            _this2.props.add(org);

            browserHistory.push("/org/".concat(org.id, "/publishing"));
          }
        };
      }) : [];
      var noResultsString = searching ? '' : 'No matching organizations found';
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: {
          zIndex: 99
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.body
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.searchWrap
      }, /*#__PURE__*/React.createElement(LLTextField, {
        floatingLabelFixed: true,
        hintText: "Search",
        name: "searchQuery",
        placeholder: "Search your Clients",
        value: this.state.value,
        onChange: this.handleChange
      })), searching ? /*#__PURE__*/React.createElement("div", {
        style: {
          height: '75px',
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement(List, {
        items: results
      }), results.length ? /*#__PURE__*/React.createElement(ReactPaginate, {
        initialPage: 0,
        forcePage: pageIndex,
        disableInitialCallback: true,
        pageCount: Math.ceil(total / limit),
        marginPagesDisplayed: 1,
        pageRangeDisplayed: 3,
        previousLabel: /*#__PURE__*/React.createElement("span", {
          className: "icon ion-ios-arrow-back"
        }),
        nextLabel: /*#__PURE__*/React.createElement("span", {
          className: "icon ion-ios-arrow-forward"
        }),
        onPageChange: this.handlePageChange,
        containerClassName: styles.container,
        pageClassName: styles.page,
        pageLinkClassName: styles.pageLink,
        activeClassName: styles.activePage,
        previousClassName: styles.previousPage,
        nextClassName: styles.nextPage,
        previousLinkClassName: styles.previousPageLink,
        nextLinkClassName: styles.nextClassLink,
        disabledClassName: styles.disabled,
        breakClassName: styles["break"]
      }) : /*#__PURE__*/React.createElement("span", null, noResultsString)));
    }
  }]);

  return OrganizationPicker;
}(Component), _defineProperty(_class2, "propTypes", {
  searchResults: PropTypes.object,
  searching: PropTypes.bool
}), _temp)) || _class);
export { OrganizationPicker as default };